export default "__VITE_ASSET___app/immutable/assets/default-avatar-2.Cpa5x_Hx.svg__"